module.exports = __webpack_public_path__ + "img/logo.80ac4bec.png";